<template>
    <div id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title" v-if="this.elm!=3">
                Enrol Users
            </v-toolbar-title>
            <v-toolbar-title class="heading-title" v-else>
                Set Deadline
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark color="white">fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <div id="slideout-container">
            <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
                <v-stepper-header v-if="this.elm!=3">
                    <v-stepper-step :complete="e1 > 1" step="1">Select Users</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="e1 > 2" step="2">Select Groups</v-stepper-step>
                </v-stepper-header>
                <v-stepper-header v-if="this.elm==3">
                    <v-stepper-step :complete="e1 > 3" step="1">Set Deadline</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="max-height-list scroll-y">
                        <h4 v-if="allUsersEnrolled">All users have been enrolled</h4>
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-text-field
                            v-model="userSearch"
                            label="Filter Users By Name"
                            type="text"
                            @change="applyUserSearch"
                            class="filter-user"
                            append-icon="fa-search"
                            ></v-text-field>
                            <v-expansion-panels accordion 
                            v-model="panel"
                            multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Assigned Users
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                              <v-btn
                                              v-on="on"
                                              class="ml-1"
                                              text
                                              x-small
                                              color="$improve-grey-900"
                                              style="width:auto;"
                                              >
                                                  <v-icon x-small>fa fa-question</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Below you will see all enrolled Users. To un-enrol Users please select them by ticking the<br> box next to their name or use the select all function to select everyone on this page. <br>Complete the process to un-enrol Users before trying to enrol more Users.</span>
                                        </v-tooltip>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-data-table
                                        v-model="selectedUsers"
                                        :headers="userHeaders"
                                        :options.sync="userOptions"
                                        :server-items-length="serverUserItemsLength"
                                        :loading="userLoading"
                                        :items="users"
                                        item-key="id"
                                        show-select
                                        class="enrol-user-list-tbl"
                                        :footer-props="{
                                        'items-per-page-options': [5,10,15]
                                        }"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>              
                        </div>
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-expansion-panels accordion
                            v-model="panel2"
                            multiple
                            >
                            <v-expansion-panel>
                                <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Unassigned Users</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="enrol_all_checkbox">
                                            <v-checkbox v-model="enrol_all" label="Select to enrol all users"></v-checkbox>
                                        </div>
                                        <v-data-table
                                        v-model="unAssignedUsers"
                                        :headers="userHeaders"
                                        :options.sync="userOptions2"
                                        :server-items-length="serverUser2ItemsLength"
                                        :loading="userLoading2"
                                        :items="users2"
                                        item-key="id"
                                        show-select
                                        class="enrol-user-list-tbl"
                                        :footer-props="{
                                        'items-per-page-options': [5,10,15]
                                        }"
                                        v-if="!enrol_all"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="max-height-list scroll-y">
                        <h4 v-if="allGroupsEnrolled">All groups have been enrolled</h4>
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-text-field
                            v-model="groupSearch"
                            label="Filter Groups By Name"
                            type="text"
                            @change="applyGroupSearch"
                            append-icon="fa-search"
                            class="filter-user"
                            ></v-text-field>
                            <v-expansion-panels accordion 
                            v-model="panel"
                            multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Groups Assigned</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-data-table
                                        v-model="selectedGroups"
                                        :headers="groupHeaders"
                                        :options.sync="groupOptions"
                                        :server-items-length="serverGroupItemsLength"
                                        :loading="groupLoading"
                                        :items="groups"
                                        item-key="id"
                                        show-select
                                        class="mb-5 enrol-user-list-tbl"
                                        :footer-props="{
                                        'items-per-page-options': [5,10,15]
                                        }"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                        <div style="border:1px solid rgba(0, 0, 0, 0.12);">
                            <v-expansion-panels accordion 
                            v-model="panel2"
                            multiple>
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Groups Unassigned</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-data-table
                                        v-model="selectedGroups2"
                                        :headers="groupHeaders"
                                        :options.sync="groupOptions"
                                        :server-items-length="serverGroupItemsLength2"
                                        :loading="groupLoading2"
                                        :items="groups2"
                                        item-key="id"
                                        show-select
                                        class="mb-5 enrol-user-list-tbl"
                                        :footer-props="{
                                        'items-per-page-options': [5,10,15]
                                        }"
                                        ></v-data-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="3" class="max-height-list">
                       <date-picker :color="datePickerColor"></date-picker>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
        <v-footer absolute height="68">
            <v-flex px-4 py-4 text-right>
                <div v-if="e1 == 1">
                    <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
                    <v-btn color="dark-blue" class="add-course-button" @click="e1 = 2">Next</v-btn>
                </div>
                <div v-if="e1 == 2 && this.elm!=3">
                    <v-btn v-if="!loading" color="grey300" class="mr-4" @click="e1 = 1">Back</v-btn>
                    <v-btn v-if="loading" color="primary" loading></v-btn>
                    <v-btn v-else color="dark-blue" class="add-course-button" @click="enrolUsers">Enrol Selected Users</v-btn>
                </div>
                <div v-if="this.elm==3">
                    <v-btn color="dark-blue" class="add-course-button" @click="enrolUsers">Set Deadline</v-btn>
                </div>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import courseAPI from "@/api/course.js";
    import userAPI from "@/api/user.js";
    import groupAPI from "@/api/group.js";
    import DatePicker from "@/components/admin/global/Datepicker";
    export default {
        name: "UserDetails",
        components: {
            DatePicker
        },
        props: {
            id: {
                type: String,
                default: null
            },
            params: {
                type: String,
                default: ""
            },
            elm: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                userHeaders: [
                    { text: "First Name", value: "first_name" },
                    { text: "Surname", value: "last_name" },
                    { text: "Email", value: "email" }
                ],
                groupHeaders: [
                    { text: "Name", value: "name" },
                    { text: "Description", value: "description" }
                ],
                panel: [0,1],
                panel2: [0,1],
                loading: false,
                e1: this.elm,
                selectedUsers: [],
                selectedGroups: [],
                userSearch: "",
                groupSearch: "",
                users: [],
                groups: [],
                userSearchParams: "",
                groupSearchParams: "",
                userOptions: {},
                groupOptions: {},
                userLoading: false,
                groupLoading: false,
                userPagination: {},
                groupPagination: {},
                selectedDate: "Not Set",
                deadlineSet: false,
                successMessage: "Users Successfully Enrolled.",
                errorMessage: "Oops, something went wrong!",
                nothingSelected: "You havent selected any Users or Groups.",
                deadlineNotSet: "You havent set a Deadline.",
                allUsersEnrolled: false,
                allGroupsEnrolled: false,
                picker: new Date().toISOString().substr(0, 10),
                userLoading2: false,
                userPagination2: {},
                users2: [],
                unAssignedUsers: [],
                groups2: [],
                groupPagination2: {},
                groupLoading2: false,
                selectedGroups2: [],
                AllPreviousEnrolledUsers: [],
                AllPreviousEnrolledGroups: [],
                enrol_all: false,
                UnEnrollNotification:"Unassigning user(s) or group(s) from this course will PERMANENTLY DELETE all their progress and completion data for all users. Are you sure you want to proceed?",
                successUnEnrollMessage: "User(s) or Group(s) are now unassigned and all their progress has been deleted. ",
                userOptions2: {},
                userUnEnrolledSearchParams: "",
            };
        },
        computed: {
            serverUserItemsLength: function() {
                return this.userPagination.total;
            },
            userItemsPerPage: function() {
                return this.userPagination.per_page;
            },
            userPage: function() {
                return this.userPagination.current_page;
            },
            userParams: function() {
                return this.$gf.getQueryString(this.userOptions, this.serverUserItemsLength);
            },
            selectedUsersTotal: function() {
                return this.selectedUsers.length;
            },
            serverGroupItemsLength: function() {
                return this.groupPagination.total;
            },
            groupItemsPerPage: function() {
                return this.groupPagination.per_page;
            },
            groupPage: function() {
                return this.groupPagination.current_page;
            },
            groupParams: function() {
                return this.$gf.getQueryString(this.groupOptions);
            },
            selectedGroupsTotal: function() {
                return this.selectedGroups.length;
            },
            serverUser2ItemsLength: function() {
                return this.userPagination2.total;
            },
            serverGroupItemsLength2: function() {
                return this.groupPagination2.total;
            },
            userUnEnrolledParams: function() {
              return this.$gf.getQueryString(this.userOptions2,this.serverUser2ItemsLength);
            },
            datePickerColor() {
                return this.$gf.headerColor();
            },
        },
        watch: {
            userOptions: {
                handler() {
                    this.getEnrolledUsers();
                    //this.getUnenrolledUsers();
                },
                deep: true
            },
            groupOptions: {
                handler() {
                    this.getGroups();
                    this.getUnenrolledGroups();
                },
                deep: true
            },
            userOptions2: {
              handler() {
                this.getUnenrolledUsers();
              },
              deep: true
            },
        },
        mounted() {
            this.setEventBus();
        },
        methods: {
            getEnrolledUsers() {
                this.userLoading = true;
                courseAPI
                .getCourseEnrolledUsers(
                    this.id,
                    this.userParams,
                    this.userSearchParams
                    )
                .then(resp => {
                    this.users = resp.data.data;
                    this.AllPreviousEnrolledUsers = resp.data.data;
                    this.userPagination = resp.data.meta.pagination;
                    this.userLoading = false;
                    //this.selectedUsers = resp.data.data;
                });
            },
            getUnenrolledUsers() {
                this.userLoading2 = true;
                courseAPI
                .getCourseUnenrolledUsers(
                    this.id,
                    this.userUnEnrolledParams,
                    this.userUnEnrolledSearchParams
                    )
                .then(resp => {
                    this.users2 = resp.data.data;
                    this.userPagination2 = resp.data.meta.pagination;
                    this.userLoading2 = false;
                    this.users2.length == 0
                    ? (this.allUsersEnrolled = true)
                    : (this.allUsersEnrolled = false);
                });
            },
            getGroups() {
                this.groupLoading = true;
                courseAPI
                .getCourseEnrolledGroups(
                    this.id,
                    this.groupParams,
                    this.groupSearchParams
                    )
                .then(resp => {
                    this.groupLoading = false;
                    this.groups = resp.data.data;
                    this.groupPagination = resp.data.meta.pagination;
                    //this.selectedGroups = resp.data.data;
                    this.AllPreviousEnrolledGroups = resp.data.data;
                    this.groups.length == 0
                    ? (this.allGroupsEnrolled = true)
                    : (this.allGroupsEnrolled = false);
                });
            },
            getUnenrolledGroups() {
                this.groupLoading = true;
                courseAPI
                .getCourseUnenrolledGroups(
                    this.id,
                    this.groupParams,
                    this.groupSearchParams
                    )
                .then(resp => {
                    this.groupLoading2 = false;
                    this.groups2 = resp.data.data;
                    this.groupPagination2 = resp.data.meta.pagination;
                });
            },
            applyUserSearch() {
                this.userSearchParams = this.userParams + "&search=first_name:" + this.userSearch + ";last_name:" + this.userSearch;
                this.userUnEnrolledSearchParams = this.userUnEnrolledParams +"&search=first_name:" +this.userSearch +";last_name:" +this.userSearch;
                this.getEnrolledUsers();
                this.getUnenrolledUsers();
            },
            applyGroupSearch() {
                this.groupSearchParams =
                this.groupParams + "&search=name:" + this.groupSearch;
                this.getGroups();
            },
            processSelectedUsers() {

                let users = [];
                this.selectedUsers.forEach(function(x) {
                    users.push(x.id);
                });
                return users;
            },
            processUnassignSelectedUsers() {
                let users = [];
                this.unAssignedUsers.forEach(function(x) {
                    users.push(x.id);
                });
              return users;
            },
            processSelectedGroups() {
                let groups = [];
                this.selectedGroups.forEach(function(x) {
                    groups.push(x.id);
                });
                return groups;
            },
            processUnassignSelectedGroups() {
                let groups = [];
                this.selectedGroups2.forEach(function(x) {
                    groups.push(x.id);
                });
                return groups;
            },
            processUnselectedUsers() {
                let removeUsers = [];
                let AllenrolledUsers = [];

                this.selectedUsers.forEach(function(x) {
                    AllenrolledUsers.push(x.id);
                });

                this.AllPreviousEnrolledUsers.forEach(function(x) {
                    if(!AllenrolledUsers.includes(x.id)) {
                        removeUsers.push(x.id);
                    }
                });
                return removeUsers;
            },
            processUnselectedGroups() {
                let removeGroups = [];
                let AllenrolledGroups = [];

                this.selectedGroups.forEach(function(x) {
                    AllenrolledGroups.push(x.id);
                });

                this.AllPreviousEnrolledGroups.forEach(function(x) {
                    if(!AllenrolledGroups.includes(x.id)) {
                        removeGroups.push(x.id);
                    }
                });

                return removeGroups;
            },
            process() {
                // this.loading = true;
                courseAPI
                .enrolUsers(this.id, {
                    assign_users: this.processSelectedUsers(),
                    unassign_users: this.processUnassignSelectedUsers(),
                    assign_groups: this.processSelectedGroups(),
                    unassign_groups: this.processUnassignSelectedGroups(),
                    selectedDate: this.selectedDate,
                    enrolAll: this.enrol_all
                })
                .then(() => {   
                    //this.removeUsersAndGroups();
                    EventBus.$emit("COURSES_UPDATED", this.params);
                    this.closePanel();
                    if((this.processSelectedUsers().length>0 && this.processUnassignSelectedUsers().length>0) || (this.processSelectedGroups().length>0 && this.processUnassignSelectedGroups().length>0)) {
                        this.$snotify.success(this.successUnEnrollMessage);
                    }
                    else if((this.processSelectedUsers().length>0 && this.processUnassignSelectedUsers().length<=0) || (this.processSelectedGroups().length>0 && this.processUnassignSelectedGroups().length<=0)) {
                        this.$snotify.success(this.successUnEnrollMessage);
                    }
                    else if((this.processSelectedUsers().length<=0 && this.processUnassignSelectedUsers().length>=0) || (this.processSelectedGroups().length<=0 && this.processUnassignSelectedGroups().length>=0)) {
                        this.$snotify.success(this.successMessage);
                    }
                    // else {
                    //     this.$snotify.success(this.successMessage);
                    // }
                    this.loading = false;
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                })
                .catch(() => {
                    this.$snotify.error(this.errorMessage);
                    this.loading = false;
                    setTimeout(() => {
                        this.$gf.removeBackdrop();
                    },300);
                });
            },
            removeUsersAndGroups() {
                courseAPI
                .removeUsersAndGroups(this.id, {
                    users: this.processUnselectedUsers(),
                    groups: this.processUnselectedGroups(),
                });
            },
            contine(toast) {
                this.$snotify.remove(toast.id);
                this.selectedDate = "";
                this.process();
            },
            setADate(toast) {
                this.$snotify.remove(toast.id);
                this.loading = false;
                this.el = 3;
            },
            enrolUsers() {
                if(this.processSelectedUsers().length >= 1 || this.processSelectedGroups().length >= 1 ) {
                    this.$snotify.confirm(this.UnEnrollNotification, {
                    backdrop:0.3,                         
                    buttons: [
                      { text: "Cancel",className: 'toast-cancel-button', },
                      {
                         text: "Yes",className: 'toast-continue-button',
                        action: toast => this.processEnrolUsers(toast)
                      }                     
                    ]
                    });
                } else {
                    this.processEnrolUsers();
                }
            },
            processEnrolUsers(toast='') {
                this.$snotify.remove(toast.id);
                this.loading = true;
                if (this.selectedUserCount + this.selectedGroupCount === 0) {
                    this.$snotify.error(this.nothingSelected);
                } else {
                    this.process();
                }
            },
            setEventBus() {
                EventBus.$on("DATE_SELECTED", date => {
                    this.deadlineSet = true;
                    this.selectedDate = date;
                });
            },
            closePanel() {
                this.$emit("closePanel", {});
            }
        }
    };
</script>
<style media="screen">
#slideout-container {
    height: calc(100vh - 65px - 100px);
}
.max-height-list {
    height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
    transition: none;
}
.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex:none;
}
.snotify-confirm .snotifyToast__body{
  font-weight: 600 !important;
}
</style>
